export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "notification": {
          "noNewNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No new notifications"])},
          "showReadNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show read notifications"])}
        }
      },
      "ru": {
        "notification": {
          "noNewNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет новых уведомлений"])},
          "showReadNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Показать прочитанные"])}
        }
      },
      "es": {
        "notification": {
          "noNewNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No hay nuevas notificaciones"])},
          "showReadNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mostrar notificaciones leídas"])}
        }
      },
      "kk": {
        "notification": {
          "noNewNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жаңа хабарландырулар жоқ"])},
          "showReadNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Оқылғандарды көрсету"])}
        }
      },
      "uz": {
        "notification": {
          "noNewNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yangi bildirishnomalar yo‘q"])},
          "showReadNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O‘qilganlarni ko‘rsatish"])}
        }
      },
      "de": {
        "notification": {
          "noNewNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine neuen Benachrichtigungen"])},
          "showReadNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gelesene Benachrichtigungen anzeigen"])}
        }
      },
      "fr": {
        "notification": {
          "noNewNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pas de nouvelles notifications"])},
          "showReadNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afficher les notifications lues"])}
        }
      },
      "it": {
        "notification": {
          "noNewNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nessuna nuova notifica"])},
          "showReadNotifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mostra le notifiche lette"])}
        }
      }
    }
  })
}
